import { del, get, post, put, patch, postMultiForm, delMultiForm, getBlob, putMultiForm } from "./api_helper";
import * as urls from "./urls";
import config from "../constants/settings";

// Method Profile

// get profile
export const getProfile = (token) => get(urls.GET_PROFILE, { headers: { ...token } });
// get employee profile
export const getEmployeeProfile = (token) => get(urls.GET_EMPLOYEE_PROFILE, { headers: { ...token } });

// Method Users

// get users admin
export const getUsersAdmin = (token, opts) => get(urls.GET_USERS_ADMIN, { params: opts, headers: { ...token } });
// get user admin
export const getUserAdmin = (token, id) => get(urls.GET_USER_ADMIN(id), { headers: { ...token } });
// get users admin roles list
export const getUsersAdminRolesList = (token) => get(urls.GET_USERS_ADMIN_ROLES_LIST, { headers: { ...token } });
// get users admin permissions list
export const getUsersAdminPermissionsList = (token, opts) => get(urls.GET_USERS_ADMIN_PERMISSIONS_LIST, { params: opts, headers: { ...token } });
// get users admin permissions by role list
export const getUsersAdminPermissionsRoleList = (token, role_id) => get(urls.GET_USERS_ADMIN_PERMISSIONS_ROLE_LIST(role_id), { headers: { ...token } });
// post create user admin
export const postUsersAdminCreate = (token, args) => post(urls.POST_USERS_ADMIN_CREATE, args, { headers: { ...token } });
// patch assign permissions user admin
// opts: { params: { type: "ADD" } }
export const patchUsersAdminPermissions = (token, user_id, args, opts) => patch(urls.PATCH_USERS_ADMIN_PERMISSIONS(user_id), args, { ...opts, headers: { ...token } });
// patch assign roles user admin
// opts: { params: { type: "ASSIGN" } }
export const patchUsersAdminRoles = (token, user_id, args, opts) => patch(urls.PATCH_USERS_ADMIN_ROLES(user_id), args, { ...opts, headers: { ...token } });
// get roles by user admin
export const getRolesAdminByUser = (token, user_id, opts) => get(urls.GET_ROLES_ADMIN_BY_USER(user_id), { ...opts, headers: { ...token } });
// get roles by user admin
export const getPermissionsAdminByUser = (token, user_id, opts) => get(urls.GET_PERMISSIONS_ADMIN_BY_USER(user_id), { ...opts, headers: { ...token } });
// put change status user admin
// opts: { params: { type: "ACTIVE" } }
export const putUsersAdminStatus = (token, user_id, opts) => put(urls.PUT_USERS_ADMIN_STATUS(user_id), {}, { ...opts, headers: { ...token } });
// put change data user admin
export const putUserAdminUpdate = (token, user_id, args) => put(urls.PUT_USER_ADMIN_UPDATE(user_id), args, { headers: { ...token } });
// del user admin eliminar
export const delUsersAdminDelete = (token, args) => del(urls.DELETE_USERS_ADMIN_DESTROY, { data: args, headers: { ...token } });

// Method Employees

// get employees admin
// opts: { name: '', members: '', budget: '', page: 1, limit: 10, skip: 0}
export const getEmployeesAdmin = (token, opts) => get(urls.GET_EMPLOYEES_ADMIN, { params: { ...opts }, headers: { ...token } });
// opts: { action: '', type_file: ''}
export const getTempleatesEmployeesAdmin = (token, opts) => get(urls.GET_TEMPLATES_EMPLOYEES_ADMIN, { params: { ...opts }, headers: { ...token } });
// get employee admin
export const getEmployeeAdmin = (token, id) => get(urls.GET_EMPLOYEE_ADMIN(id), { headers: { ...token } });
// post employees admin import
export const postEmployeesAdminImport = (token, data, opts) => postMultiForm(urls.POST_EMPLOYEES_ADMIN_IMPORT, data, { params: { ...opts }, headers: { ...token } });
// del employees admin import
export const delEmployeesAdminImportDelete = (token, data, opts) => delMultiForm(urls.DEL_EMPLOYEES_ADMIN_IMPORT_DELETE, { data, params: { ...opts }, headers: { ...token } });
// post create employee admin
export const postEmployeesAdminCreate = (token, args) => post(urls.POST_EMPLOYEES_ADMIN_CREATE, args, { headers: { ...token } });
// del employee admin eliminar
export const delEmployeesAdminDelete = (token, args) => del(urls.DELETE_EMPLOYEES_ADMIN_DESTROY, { data: args, headers: { ...token } });
// del employee admin eliminar
export const putEmployeesAdminStatus = (token, status, args, opts) => putMultiForm(urls.PUT_EMPLOYEES_ADMIN_IMPORT_STATUS, args, { params: { ...opts , status: status }, headers: { ...token } });
// put edit employee admin
export const putEmployeesAdminUpdate = (token, employee_id, args) => put(urls.PUT_EMPLOYEES_ADMIN_CREATE(employee_id), args, { headers: { ...token } });

// Method Employees Address

// post create employee address admin
export const postEmployeesAdminCreateAddress = (token, employee_id, args) => post(urls.POST_EMPLOYEES_ADMIN_CREATE_ADDRESS(employee_id), args, { headers: { ...token } });
// get list addresses employee
export const getAddressesEmployee = (token, employee_id, opts) => get(urls.GET_ADDRESSES_ADMIN_EMPLOYEE(employee_id), { params: { ...opts }, headers: { ...token } });
// get list address employee
export const getAddressEmployee = (token, employee_id, id) => get(urls.GET_ADDRESS_ADMIN_EMPLOYEE(employee_id, id), { headers: { ...token } });
// put update address employee
export const putEmployeesAdminUpdateAddress = (token, employee_id, id, args) => put(urls.PUT_ADDRESS_ADMIN_EMPLOYEE(employee_id, id), args, { headers: { ...token } });
// del remove address employee
export const delAddressEmployee = (token, employee_id, id) => del(urls.DEL_ADDRESS_ADMIN_EMPLOYEE(employee_id, id), { headers: { ...token } });

// Method Cost-Center

// get cost-center admin
// opts: { name: '', members: '', budget: '', page: 1 }
export const getCostCentersAdmin = (token, opts) => get(urls.GET_COST_CENTERS_ADMIN, { params: { ...opts }, headers: { ...token } });
// opts: { name: '', members: '', budget: '', page: 1 }
export const getCostCentersAdminNotEmployees = (token, opts) => get(urls.GET_COST_CENTERS_ADMIN_NOT_EMPOLOYEES, { params: { ...opts }, headers: { ...token } });
// post create cost-center admin
export const postCostCentersAdminCreate = (token, args) => post(urls.POST_COST_CENTER_ADMIN_CREATE, args, { headers: { ...token } });
// put update cost-center admin
export const putCostCentersAdminUpdate = (token, cost_center_id, args) => put(urls.PUT_COST_CENTER_ADMIN_UPDATE(cost_center_id), args, { headers: { ...token } });
// del cost-center admin delete
export const delCostCenterDelete = (token, cost_center_id) => del(urls.DEL_COST_CENTER_DELETE(cost_center_id), { headers: { ...token } });
// get cost-center admin
export const getCostCenterAdmin = (token, cost_center_id) => get(urls.GET_COST_CENTER_ADMIN(cost_center_id), { headers: { ...token } });
// get cost-center employees admin
export const getCostCenterEmployees = (token, cost_center_id, opts) => get(urls.GET_COST_CENTER_EMPLOYEES_ADMIN(cost_center_id), { params: { ...opts }, headers: { ...token } });
// put cost-center add employees admin
export const putCostCenterEmployees = (token, cost_center_id, args) => put(urls.PUT_COST_CENTER_EMPLOYEES_ADMIN(cost_center_id), args, { headers: { ...token } });
// del cost-center add employees admin
export const delCostCenterEmployees = (token, cost_center_id, args) => del(urls.DEL_COST_CENTER_EMPLOYEES_ADMIN(cost_center_id), { data: args, headers: { ...token } });
// get cost-centers reports admin
export const getCostCentersReports = (token, cost_center_ids, type_file) => getBlob(urls.GET_COST_CENTER_REPORTS_ADMIN, { params: { cost_center_ids, type_file }, headers: { ...token } });
// get cost-center report admin
export const getCostCenterReport = (token, cost_center_id, type_file) => getBlob(urls.GET_COST_CENTER_REPORT_ADMIN(cost_center_id), { params: { type_file }, headers: { ...token } });
// get cost-center policy employees admin
export const getCostCenterCreatePolicyEmployee = (token, cost_center_id, employee_id) => get(urls.GET_COST_CENTER_POLICY_EMPLOYEE_ADMIN(cost_center_id, employee_id), { headers: { ...token } });
// put cost-center update policy employees admin
export const putCostCenterUpdatePolicyEmployee = (token, cost_center_id, employee_id, args) => put(urls.PUT_COST_CENTER_POLICY_EMPLOYEE_ADMIN(cost_center_id, employee_id), args, { headers: { ...token } });
// post create policy employee admin
export const postCostCenterCreatePolicyEmployee = (token, cost_center_id, employee_id, args) => post(urls.POST_COST_CENTER_POLICY_EMPLOYEE_ADMIN(cost_center_id, employee_id), args, { headers: { ...token } });
// get cost-centers sub-admins list
export const getSubAdminsCostCenter = (token, opts) => get(urls.GET_SUB_ADMINS_COST_CENTER, { params: {...opts}, headers: {...token} });
// post to create a sub-admin of a cost center
export const postCreateSubAdminsCostCenter = (token, args) => post(urls.POST_CREATE_SUB_ADMINS_CONST_CENTER, args, { headers: { ...token } });
// del to delete a sub-admin of a cost center
export const delSubAdminsCostCenter = (token, data) => del(urls.DEL_SUB_ADMINS_COST_CENTER, { data, headers: { ...token } });

// Method Services

// get services admin
export const getServicesAdmin = (token, opts) => get(urls.GET_SERVICES_ADMIN, { params: { ...opts }, headers: { ...token } });
// get services admin
export const getServiceAdmin = (token, id, opts) => get(urls.GET_SERVICE_ADMIN(id), { params: { ...opts }, headers: { ...token } });
// get services request admin
export const getServiceRequestAdmin = (token, id, opts) => get(urls.GET_SERVICE_REQUEST_ADMIN(id), { params: { ...opts }, headers: { ...token } });
// post services admin
export const postServicesAdmin = (token, args) => post(urls.POST_SERVICES_ADMIN, args, { headers: { ...token } });
// pathch services admin
export const pathcStatusServicesAdmin = (token, args) => patch(urls.PATCH_STATUS_SERVICES_ADMIN, args, { headers: { ...token } });
// patch unassign services
export const patchUnassignServices = (token, args) => patch(urls.PATCH_UNASSIGN_SERVICES, args, { headers: { ...token } });
// post services arrival admin
export const postServicesArrivalAdmin = (token, data) => postMultiForm(urls.POST_SERVICES_ARRIVAL_ADMIN, data, { headers: { ...token } });
// post services arrival admin
export const postServicesLeavingAdmin = (token, data) => postMultiForm(urls.POST_SERVICES_LEAVING_ADMIN, data, { headers: { ...token } });
// del services arrival admin
export const delServicesCancelAdmin = (token, data) => del(urls.DEL_SERVICES_ADMIN, { data, headers: { ...token } });
// del services arrival admin
export const delServicesCancelReservAdmin = (token, data) => del(urls.DEL_SERVICES_RESERV_ADMIN, { data, headers: { ...token } });
// post services assign admin
export const postServicesAssignAdmin = (token, args) => post(urls.POST_SERVICES_ASSIGN_ADMIN, args, { headers: { ...token } });
// put platform request
export const putPlatformRequest = (token, data) => put(urls.PUT_PLATFORM_REQUEST, data, { headers: { ...token } });
 // patch update request info
export const patchUpdateRequest = (token, id, data) => patch(urls.PATCH_UPDATE_REQUEST, data, { headers: { ...token } });
// get map clip services
export const getMapClipServices = (token, id, opts) => get(urls.GET_MAP_CLIP_SERVICES(id), { params: { ...opts }, headers: { "X-API-Key": `${config.apiKeys.mapClip}` } });
//post services notes (bookings)
export const postCreateNotesServices = (token, id, data) => post(urls.POST_CREATE_NOTE(id), data, { headers: {...token } });
//get list services notes (bookings)
export const getListNotesServices = (token, id, opts) => get(urls.GET_LIST_NOTES(id), { params: { ...opts }, headers: { ...token } });
// patch end service without passenger
export const patchEndServiceWithoutPassenger = (token, id, args) => patch(urls.PATCH_END_WITHOUT_PASSENGER(id), args, { headers: { ...token } });
// get employee service requests
export const getEmployeeRequests = (token, opts) => get(urls.GET_EMPLOYEE_REQUESTS, { params: { ...opts }, headers: { ...token } });
// get employee service bookings
export const getEmployeeBookings =(token, opts) => get(urls.GET_EMPLOYEE_BOOKINGS, { params: { ...opts }, headers: { ...token } });
// get trips timeline
export const getTripsTimeline = (token, opts) => get(urls.GET_TRIPS_TIMELINE, { params: { ...opts }, headers: { ...token } });
// patch update service note
export const patchUpdateServiceNote = (token, id, data) => patch(`/api/v1/taxi/platform/bookings/notes?code=${id}`, data, { headers: { ...token }, });
// post pre request service
export const postPreRequestService = (token, args) => post(urls.POST_PRE_REQUEST, args, { headers: { ...token } });
// get pre request service
export const getPreRequestService = (token, opts) => get(urls.GET_PRE_REQUEST, { params: { ...opts }, headers: { ...token } });
  
// Routes and Stops

// get routes
export const getRoutes = ({ token, partner_id, cost_center_id, ...opts }) => get(urls.GET_ROUTES(partner_id, cost_center_id), { params: opts, headers: { ...token } });
// get route stops
export const getRouteStops = ({ token, partner_id, route_id, ...opts }) => get(urls.GET_ROUTES_STOPS(partner_id, route_id), { params: opts, headers: { ...token } });

// Method Drivers

// get drivers available admin
export const getDriversAvailableAdmin = (token) => get(urls.GET_DRIVERS_AVAILABLE_ADMIN, { headers: { ...token } });

// Method Orgs

// get orgs admin
export const getOrgsAdmin = (token) => get(urls.GET_ORGS_ADMIN, { headers: { "X-API-Key": `${config.apiKeys.partners}` } });

// Sync Coke Trips

// get import coke routes
export const getImportCokeRoutes = (token) => get(urls.GET_IMPORT_COKE_ROUTES, { headers: { ...token } });
// get task progress
export const getTaskProgress = (token, task_id) => get(urls.GET_TASK_PROGRESS(task_id), { headers: { ...token } });

//
// get plates
export const getPlates = (status, page, size, plate = '') => get(urls.GET_PLATES(status, page, size, plate), { headers: { "X-API-Key": `${config.apiKeys.plates}` }, });
//get plates to onboard api
export const getPlatesOnboard = (business_line, page, size, plate = '') => get(urls.GET_PLATES_ONBOARD(business_line, page, size, plate), { headers: {"X-API-Key": `${config.apiKeys.platesOnboard}` }, });

 // Gpx Studio

 // get trip resume
 export const getTripsResume = (code, type = 'gpx') => get(urls.GET_TRIPS_RESUME(code, type), { headers: { "X-API-Key": `${config.apiKeys.tripResume}` } });

// Method Validation Locations

// post valid locations
// export const postValidLocations = (args) => post(urls.POST_VALIDATION_LOCATIONS, args, { headers: { "X-API-key": `${config.apiKeys.addressValidation}` } });